module.exports = __webpack_public_path__ + "static/media/simple.99e648ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/simple.jpg
// module id = 745
// module chunks = 0